var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"my-2"},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_vm._v(_vm._s(_vm.count)+" "+_vm._s(_vm.title))]),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"primary","small":""},on:{"click":function($event){return _vm.refresh()}}},[_vm._v("Refresh")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }